var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('floob-meal-update-dialog',{attrs:{"dialog":_vm.mealUpdateDialog},on:{"update:dialog":function($event){_vm.mealUpdateDialog=$event},"closed":_vm.onClosedMeal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }